// extracted by mini-css-extract-plugin
export default {"beforeFooterText":"applications-components-ProductsApp-components-SeoTexts-seo-texts-module__beforeFooterText","tabsBlock":"applications-components-ProductsApp-components-SeoTexts-seo-texts-module__tabsBlock"};
    if(module.hot) {
      // 1791528099500
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  